import React, { useEffect, useState } from "react";
import { GET } from "../../utils/fetchUtil";
import Box from "../../common/box/Box";
import { Column, Row } from "../../common/columns";
import { isTouch } from "../../utils/screenUtil";
import InputField from "../../common/input/InputField";
import { useDebounce } from "../../common/hooks/useDebounce";
import { useTranslation } from "react-i18next";
import Content from "../../common/content/Content";
import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../common/loader/Loader";
import FetchButton from "../../common/button/FetchButton";

function RequestArchivePage() {
  const [request, setRequest] = useState(undefined);
  const [archive, setArchive] = useState([]);
  const [query, setQuery] = useState("");
  const debouncedQuery = useDebounce(query, 250);
  const [hidden, setHidden] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    GET(
      "/archive" +
        (debouncedQuery.length > 0 ? `?query=${encodeURIComponent(debouncedQuery)}` : ""),
      (response) => {
        setRequest(response);
      }
    );
  }, []);

  useEffect(() => {
    request &&
      setArchive(
        request.sort(function (dateA, dateB) {
          return new Date(dateB.receiptDate) - new Date(dateA.receiptDate);
        })
      );
  }, [request]);

  useEffect(() => {
    request &&
      (query.length > 0
        ? setArchive(
            request.filter((req) =>
              req.title.toString().toLowerCase().includes(query.toLowerCase())
            )
          )
        : setArchive(
            request.filter((req) =>
              req.title.toString().toLowerCase().includes(query.toLowerCase())
            )
          ));
  }, [query, request]);

  useEffect(() => {
    if (query.length > 0 && archive.length === 0) {
      setHidden(false);
    } else if (archive.length !== 0) {
      setHidden(true);
    }
  }, [archive.length, query.length]);

  if (request) {
    return (
      <div className={"ml-2 mr-2 is-flex-grow-1"}>
        <div className="mt-2 mb-5 is-flex is-flex-direction-row-reverse">
          <div className="field control" style={{ width: isTouch() ? "100%" : "25%" }}>
            <InputField
              placeholder={t("requests.archivePage.searchInputFieldPlaceholder")}
              onChange={(e) => setQuery(e.currentTarget.value)}
              value={query}
            />
          </div>
        </div>
        <Content isScrollable={true} /*height={870}*/>
          <div className="subtitle has-text-weight-bold ml-6">Arhiva</div>
          {!hidden && <div className="subtitle ml-6">Nema rezultata.</div>}
          {archive.map((request, index) => (
            <Box key={"request" + index} defaultPadding={false}>
              <Row>
                <Column className={"is-size-6"}>{request.title}</Column>
                <Column>
                  {t("requests.archivePage.subject")}: {request.subject}
                </Column>
                {/* <Column>
                  {t("requests.archivePage.registerNumber")}: {request.registerNumber}
                </Column> */}
                <Column>
                  {t("requests.archivePage.receiptDate")}:{" "}
                  {format(new Date(request.receiptDate), "dd.MM.yyyy")}
                </Column>
                <Column>
                  {t("requests.archivePage.confirmationDate")}:{" "}
                  {format(new Date(request.confirmationDate), "dd.MM.yyyy")}
                </Column>
                <Column className={"has-text-right"}>
                  <button className={"button has-background-white is-white"}>
                    <FontAwesomeIcon
                      icon={faLock}
                      size="2x"
                      title={t("requests.archivePage.titleInfo")}
                    />
                  </button>
                  <FetchButton
                    href={request.href}
                    className={"button has-background-white is-white"}
                    text={
                      <FontAwesomeIcon
                        icon={faFilePdf}
                        size="2x"
                        className="has-text-danger ml-4"
                      />
                    }
                  />
                </Column>
              </Row>
            </Box>
          ))}
        </Content>
      </div>
    );
  } else {
    return <Loader size={`8x`} className="is-flex-grow-1 is-align-self-center" />;
  }
}

export default RequestArchivePage;
